"use client"
import {SolidLogin} from "@solidstarters/solid-core-ui";

const LoginPage = () => {
  return (
    <div>
      <SolidLogin />
    </div>
  );
};

export default LoginPage;
